/**
 * 017: structure copied from
 * vendor/isomorphic/apps/isomorphic/src/app/shared/roles-permissions/users-table/columns.tsx
 * (non-ecommerce, same source `customers/columns.tsx` cites) for the identity/AvatarCard-style
 * layout. The actions cell is `InvitationActions` (./invitation-actions.tsx), its own file rather
 * than inline here — see that file's own header for why.
 *
 * Only the data, columns and labels are ours.
 */
import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "rizzui";
import { formatDate, roleName } from "../../lib/format";
import type { InvitationSummary } from "../../lib/services/invitations";
import { InvitationActions } from "./invitation-actions";

export const invitationColumns: ColumnDef<InvitationSummary>[] = [
  {
    id: "email",
    accessorFn: (row) => row.email ?? "",
    header: "Email",
    size: 280,
    cell: ({ row }) => <span className="font-medium text-gray-900">{row.original.email ?? "—"}</span>,
  },
  {
    id: "role",
    accessorKey: "role",
    header: "Role",
    size: 200,
    cell: ({ row }) => (
      <Badge variant="flat" color="secondary" rounded="md" >
        {roleName(row.original.role)}
      </Badge>
    ),
  },
  {
    id: "createdAt",
    accessorKey: "createdAt",
    header: "Sent",
    size: 150,
    cell: ({ row }) => formatDate(row.original.createdAt),
  },
  {
    id: "expiresAt",
    accessorKey: "expiresAt",
    header: "Expires",
    size: 150,
    cell: ({ row }) => formatDate(row.original.expiresAt),
  },
  {
    id: "actions",
    header: "",
    size: 90,
    cell: ({ row }) => <InvitationActions invitation={row.original} />,
  },
];
